import { __rest } from 'tslib';
import React from 'react';
import { styled, LazyImage } from '@teko/ui';
import { c as cashIcon } from './cash-3b5b6f79.js';

var Voucher = "https://shopfront-cdn.tekoapis.com/static/071b0994e39e244d.svg";

var PromoItemType;
(function (PromoItemType) {
    PromoItemType["GIFT"] = "gift";
    PromoItemType["DISCOUNT"] = "discount";
    PromoItemType["VOUCHER"] = "voucher";
})(PromoItemType || (PromoItemType = {}));
const Container = styled.div `
  display: flex;
  align-items: center;
`;
const StyledImg = styled(LazyImage)(({ hasBorder, theme: { colors } }) => `
    height: 2.5rem;
    max-width: 2.5rem;
    min-width: 2.5rem;
    border-radius: 0.25rem;
    border: none;
    overflow: hidden;
    padding: 0;
    margin: 0;
    border: ${hasBorder ? `1px solid ${colors.border}` : 'none'};
  `);
const Text = styled.p(({ theme: { colors } }) => `
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${colors.text};
    font-size: 0.8125rem;
    line-height: 1.25rem;
    font-weight: 500;
    margin-left: 0.75rem;
  `);
const PromoItem = (_a) => {
    var { type, text, imgSrc } = _a, props = __rest(_a, ["type", "text", "imgSrc"]);
    const isGift = type === PromoItemType.GIFT;
    return (React.createElement(Container, Object.assign({}, props),
        React.createElement(StyledImg, { hasBorder: isGift, src: isGift ? imgSrc : type === PromoItemType.DISCOUNT ? cashIcon : Voucher }),
        React.createElement(Text, null, text)));
};

export { PromoItemType as P, PromoItem as a };
